import { Box, Button, Chip, Grid, Link, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { BID_STATUS, BID_TYPE } from "../../util/bid/bidConstants";
import { convertFullDayToShort } from "../../util/bid/bidFormUtils";
import { getShiftDate } from "../../util/dateTimeFormatter";
import BidTimer from "../bid/BidTimer";
import { isAssignmentUsedToDisplay } from "../../util/bid/shiftBidUtils";

const DashboardEmployeeBid = (props) => {
  const renderAwardResults = () => {
    switch (props.bid.bidType) {
      case BID_TYPE.SHIFT:
        return (
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={{ color: "primary.swaBlue", fontWeight: "bold" }}>
                Bid Line {props.bid.awarded.lineNumber}
              </Typography>
            </Grid>
            {props.bid.awarded.shifts.map((shift) => {
              return (
                <Grid container key={shift.day}>
                  <Grid item xs={3} sx={{ fontWeight: "bold" }}>
                    {convertFullDayToShort(shift.day)}
                  </Grid>
                  <Grid item xs={5}>
                    {shift.isOff ? "OFF" : `${shift.start} - ${shift.end}`}
                  </Grid>
                  <Grid item xs={4}>
                    {isAssignmentUsedToDisplay(props.bid)
                      ? !shift.isOff && shift.assignment
                      : !shift.isOff && shift.position}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        );
      case BID_TYPE.FREEDAY:
      case BID_TYPE.FTO:
      case BID_TYPE.IAM_DAT:
      case BID_TYPE.TWU_DAT_FTO:
      case BID_TYPE.NC_PTO_GOC_HOL:
      case BID_TYPE.NC_PTO_FTO:
        return (
          <Grid container>
            {props.bid.awarded?.awardedDays.map((awardedDay) => {
              return (
                <Grid container key={awardedDay.date}>
                  <Grid item xs={3} sx={{ fontWeight: "bold" }}>
                    {awardedDay.date.toFormat("ccc").toUpperCase()}
                  </Grid>
                  <Grid item xs={5}>
                    {awardedDay.date.toFormat("MM/dd/yyyy")}
                  </Grid>
                  <Grid item xs={4}>
                    {awardedDay.timeOffType && <Grid item>{awardedDay.timeOffType}</Grid>}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        );
      default:
        return "Unknown Bid Type";
    }
  };

  const isActionAvailable = () => {
    return [BID_STATUS.OPEN, BID_STATUS.CLOSED].includes(props.bid.status);
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={7}>
          <Typography fontSize={14} fontWeight="bold" textAlign="left" letterSpacing={2} pt={2} pb={2}>
            {props.bid.bidType.toUpperCase()}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
          <Chip label={props.bid.status} variant="outlined" color="primary" />
        </Grid>
      </Grid>
      <Paper elevation={1} sx={{ marginBottom: "10px", padding: "20px", verticalAlign: "middle" }}>
        <Grid container sx={{ textAlign: "left" }} alignItems="center">
          <Grid item xs={12} sx={{ marginBottom: "10px", fontSize: "16px" }}>
            {props.bid.station} | {props.bid.workgroup} | {getShiftDate(props.bid.schedStartDate)} -{" "}
            {getShiftDate(props.bid.schedEndDate)}
          </Grid>
          {props.bid.status === BID_STATUS.OPEN && (
            <Grid container sx={{ color: "primary.swaRed", marginTop: "10px", marginBottom: "10px" }}>
              <Grid item xs={12}>
                <BidTimer
                  windowDates={[props.bid.windowStartDate, props.bid.windowEndDate]}
                  station={props.bid.station}
                />
              </Grid>
            </Grid>
          )}
          {props.bid.status === BID_STATUS.AWARDED && renderAwardResults()}
          {isActionAvailable() && (
            <Grid item xs={12}>
              <Link href={`#/bidChoices/${props.bid.referenceNumber}/${props.bid.eid}`}>
                <Button color="primary" variant="contained" sx={{ color: "secondary.swaWhite", fontWeight: "bold" }}>
                  BID FORM
                </Button>
              </Link>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

DashboardEmployeeBid.propTypes = {
  bid: PropTypes.object.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default DashboardEmployeeBid;
